import React from 'react';
import {Navbar, FluidContainer} from '../../components';
import {Link} from 'react-router-dom';
import {ARMcontext} from '../../utils/context/context';

export default () => {
  const {test, startTest} = React.useContext(ARMcontext);
  return (
    <>
      <Navbar />
      <FluidContainer>
        <div>
          <div>
            <h1>Hola arm care</h1>
            <span>Mi pan {test}</span>
          </div>
          <div>
            <button onClick={() => startTest(test + 'su ')}>Click</button>
          </div>
          <div>
            <Link to="/dashboard">Dashboard</Link>
          </div>
          <div>
            <Link to="/login">Login</Link>
          </div>
        </div>
      </FluidContainer>
    </>
  );
};
